import { h } from 'preact'
import styled from 'styled-components'
import png from './select.png'

const Select = styled.select`
  box-sizing: content-box;
  text-overflow: ellipsis;
  overflow: hidden;
  text-indent: 10px;
  padding: 2px 31px 2px 4px;
  width: ${props => props.width || 306}px;
  height: 34px;
  box-shadow: none;
  background: #fff url(${png}) right 0 no-repeat;
  appearance: none;

  margin: ${props => (props.error ? '0px 0px 20px 0px' : '1px 1px 21px 1px')};
  border: ${props => (props.error ? '1px solid #fa4624' : 0)};

  font-family: 'chaparral-pro', serif;
  font-size: 18px;
  line-height: 40px;
  cursor: pointer;
  outline: none;
  :focus {
    margin: 0px 0px 20px 0px;
    border: 1px solid ${props => (props.error ? '#fa4624' : '#4d90fe')};
  }
  :-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
`

const Option = styled.option``

/*
<Box
  {...getInputProps()}
  type="button"
  onClick={toggleMenu}
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded={isOpen}
>
  {selectedItem || props.default || 'Select an item'}
</Box>
*/

export default function Dropdown(props) {
  const { items, onChange } = props
  return (
    <Select
      onChange={evt => onChange(evt.target.value)}
      width={props.width}
      className={props.className}
    >
      {items.map(item => (
        <Option
          selected={props.value === item.key}
          key={item.key}
          value={item.key}
        >
          {item.display}
        </Option>
      ))}
    </Select>
  )
}



// WEBPACK FOOTER //
// ./components/atoms/select/select.js